module.exports = __webpack_public_path__ + "static/media/ylemine_jan_025.f2901371.webp";